module.exports = __webpack_public_path__ + "static/media/zalo-1.9087cf4a.svg";